import { Provider } from 'react-redux';
import React from 'react';
import { render } from 'react-dom';
import { matchPath } from 'react-router-dom';
import { store } from './store';
import { App } from './modules/app/components/App';
import '@myua/kit/dist/aa-kit.css';
import '@myua/api/src/styles.scss';
import { initSentry } from '@myua/sentry';
import { KitProvider } from '@myua/kit';
import { cssVarKey } from '../general/model';
import { KitMethodsInitializer } from '../general/kitMethods';
import { FontLicenseProvider, LicenseConfirmationModal } from '../general/fontLicense';
import { bootstrapWithAuth, waitForStoreState } from '../general/authGate';
import * as appActions from './modules/app/actions';
import { getInitialized } from './modules/app/selectors';
import { routes } from './modules/router/model';
import { parseLocationDemoUpload, saveDemoUploadIntent } from './modules/demoWelcome/model';

initSentry();

// Публичная страница Asset Lab — шаренная ссылка (/sharing/:sharingId/). Её должно
// открывать без логина, поэтому для неё gate НЕ редиректит на /login/.
// Матчим так же, как lastState/listeners.ts определяет isSharingPage.
const isSharingPage = () =>
  Boolean(matchPath((window.location.hash || '').substring(1), routes.sharing));

// Спецссылка Demo-инстанса (?demo_upload=1, MYUA-17010): сохраняем намерение ДО
// авторизации — внешняя страница регистрации/логина может потерять ?redirect=.
// Флаг инстанса здесь ещё неизвестен (настройки требуют авторизации), поэтому
// сохраняем всегда; потребляется только при demo_welcome_mode_enabled, иначе
// очищается (см. modules/demoWelcome/listeners.ts).
if (parseLocationDemoUpload()) saveDemoUploadIntent();

// Авторизация — первый блокирующий шаг: пока не убедились, что юзер залогинен (или
// что это публичная страница), не рендерим UI и не стартуем main() (а значит и
// aa-header). См. authGate + MYUA-16502.
void bootstrapWithAuth({
  allowAnonymous: isSharingPage,
  startApp: (user) => {
    // Юзер (если есть) загружен gate'ом — кладём в стор ДО main(), чтобы листенеры
    // (loadAndApplyLastState и загрузка фильтров) сразу видели права доступа и не
    // грузили юзера повторно.
    if (user) {
      store.dispatch(appActions.userLoaded({ user }));
    }
    store.dispatch(appActions.main());
  },
  // Держим сплеш, пока не собран первый экран: app.initialized становится true после
  // loadAndApplyLastState (см. modules/app/listeners.ts). Так на медленном соединении
  // сайдбар/шапка/контент не «выпрыгивают» по одному из-под уже снятого оверлея.
  waitUntilReady: () => waitForStoreState(store, getInitialized),
  renderApp: () =>
    render(
      <Provider store={store}>
        <KitProvider cssVarKey={cssVarKey}>
          <KitMethodsInitializer />
          <FontLicenseProvider>
            <App />
            <LicenseConfirmationModal />
          </FontLicenseProvider>
        </KitProvider>
      </Provider>,
      document.getElementById('assetlab'),
    ),
});
